export default __webpack_public_path__ + "static/media/Post-Listing-Microsite-Listed-Blocks-3.f9fadf8a.png";